{
  "title": "نظرة عامة",
  "description": "حالة سيرفراتك واشتراكاتك ونقاط الذكاء الاصطناعي.",
  "greeting": "أهلًا {{name}}، هذا ملخص {{org}} اليوم.",
  "trial": {
    "title": "تجربتك المجانية",
    "daysLeft_zero": "تنتهي اليوم",
    "daysLeft_one": "يوم متبقٍ",
    "daysLeft_two": "يومان متبقيان",
    "daysLeft_few": "أيام متبقية",
    "daysLeft_many": "يومًا متبقيًا",
    "daysLeft_other": "يوم متبقٍ",
    "noCard": "تنتهي التجربة في {{date}}. جهّز الدفع الآن حتى تستمر سيرفراتك بدون انقطاع، ولا نخصم أي مبلغ قبل نهاية التجربة.",
    "withCard": "الدفع جاهز، والاشتراك المدفوع يبدأ تلقائيًا في {{date}}. يمكنك تغيير الباقة قبل ذلك.",
    "progress": "أيام التجربة المستخدمة",
    "setUp": "جهّز الدفع"
  },
  "stats": {
    "label": "ملخص",
    "servers": "السيرفرات",
    "allServers": "كل السيرفرات",
    "accounts": "حسابات الاستضافة",
    "ofCapacity": "من {{n}}",
    "accountsHint": "على كل السيرفرات المفعّلة",
    "renewal": "التجديد القادم",
    "firstCharge": "بعد التجربة",
    "renewsOn": "في {{date}} لـ {{host}}",
    "afterTrial": "شهريًا من {{date}}، لا يشمل الضريبة",
    "noRenewal": "لا يوجد تجديد قادم",
    "billing": "الفوترة",
    "credits": "نقاط الذكاء الاصطناعي المتبقية",
    "creditsLink": "تفاصيل النقاط"
  },
  "alerts": {
    "title": "يحتاج انتباهك",
    "none": "لا يوجد ما يحتاج انتباهك.",
    "view": "عرض",
    "follow": "تابع",
    "grace": {
      "title": "{{host}} غير متصل بـ bPanel",
      "body": "المواقع تعمل. إذا لم يتصل السيرفر قبل {{date}} تتوقف إضافة حسابات جديدة حتى يتصل."
    },
    "restricted": {
      "title": "{{host}} غير متصل منذ مدة",
      "body": "المواقع تعمل، لكن إضافة الحسابات متوقفة حتى يتصل السيرفر بـ bPanel."
    },
    "pending": {
      "title": "{{host}} بانتظار التثبيت",
      "body": "ثبّت bPanel على السيرفر بمفتاح التفعيل ليتفعّل الاشتراك.",
      "action": "خطوات التثبيت"
    },
    "installing": {
      "title": "جارٍ تثبيت bPanel على {{host}}",
      "body": "يتفعّل الاشتراك تلقائيًا مع آخر خطوة."
    },
    "ending": {
      "title": "اشتراك {{host}} ينتهي في {{date}}",
      "action": "إبقاء الاشتراك"
    },
    "capacity": {
      "title": "{{host}} وصل إلى {{used}} من {{total}} حساب",
      "body": "اختر باقة أكبر قبل أن تمتلئ السعة.",
      "bodyHost": "باقة Host تسمح بحسابات إضافية، وكل حساب فوق السعة يُحسب مع التجديد.",
      "action": "الباقة"
    },
    "update": {
      "title": "الإصدار {{version}} متاح لـ {{host}}"
    },
    "locked": {
      "title": "لوحة تحكم {{host}} مقفلة",
      "body": "انتهى الاشتراك. المواقع والبريد وقواعد البيانات وDNS تعمل، ولا نحذف أي شيء. جدّد لفتح اللوحة.",
      "action": "جدّد الآن"
    },
    "unlocking": {
      "title": "تم تجديد {{host}}، وستُفتح اللوحة قريبًا",
      "body": "تُفتح لوحة التحكم عند أول اتصال للسيرفر بـ bPanel، وعادةً خلال دقائق."
    },
    "firstPayment": {
      "title": "{{host}} بانتظار أول دفعة",
      "body": "ادفع أول فترة حتى تظهر خطوات التثبيت ومفتاح التفعيل.",
      "action": "ادفع وثبّت"
    }
  },
  "servers": {
    "title": "سيرفراتك"
  },
  "quick": {
    "title": "إجراءات سريعة",
    "addServer": "إضافة سيرفر",
    "activate": "تفعيل برمز",
    "invite": "دعوة عضو",
    "ticket": "فتح تذكرة دعم"
  },
  "activity": {
    "title": "آخر النشاطات",
    "empty": "لا توجد نشاطات بعد."
  }
}
